import Table, { SORTER_STRING } from '../components/Table';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';



function UnreadFeedbackTable({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const brandFilter = useSelector((state) => state.shownData.brandFilter);
    const data = common.filterByBrand(useSelector((state) => state.shownData.unreadFeedback), brandFilter);
    const sortedData = [...data].sort((a, b) => {
        return a["query_start"] > b["query_start"] ? 1 : -1;
    });

    useEffect(() => {
        dispatch(fetch.unreadFeedback());
    }, []);



    return (
        <Table
            style={{ width: '100%' }}
            columnNames={[
                "Reisi kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Juht",
                "Maksumus",
                "Arve nr",
                "Tulemus",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/job/" + row["query_id"])}>{common.displayDepart(row)}</a>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"] || (<i style={{ color: "#668" }}>{row["query_fullname"]}</i>)}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDriver(row)}</p>),
                (row) => (<p>{common.displayPrice(row["query_response_price"])}</p>),
                (row) => (<p>{row["job_sequential_id"]}</p>),
                (row) => {
                    if (!row["job_feedbacks"]) return <p>-</p>;
                    const feedbacks = JSON.parse(row["job_feedbacks"]);
                    if (!feedbacks || feedbacks.length === 0) return <p>-</p>;

                    const positiveCount = feedbacks.filter(f => f.wentWell).length;
                    const totalCount = feedbacks.length;
                    const totalDrivers = 1 + (row["job_extra_drivers"] ? JSON.parse(row["job_extra_drivers"]).length : 0);
                    const missingCount = totalDrivers - totalCount;

                    const parts = [];
                    if (positiveCount > 0) {
                        parts.push(<span key="good" style={{ color: 'green' }}>✓ {positiveCount} hea</span>);
                    }
                    const badCount = totalCount - positiveCount;
                    if (badCount > 0) {
                        parts.push(<span key="bad" style={{ color: 'red' }}>✗ {badCount} halb</span>);
                    }
                    if (missingCount > 0) {
                        parts.push(<span key="missing" style={{ color: 'gray' }}>({missingCount} puudu)</span>);
                    }

                    if (parts.length > 0) {
                        return <p>{parts.reduce((prev, curr) => [prev, ', ', curr])}</p>;
                    }
                },
            ]}
            columnSorters={[
                (a, b) => common.sortDepart(a, b),
                ({ query_company: a }, { query_company: b }) => SORTER_STRING(a, b),
                null,
                null,
                ({ job_sequential_id: a }, { job_sequential_id: b }) => (+a) - (+b),
                (a, b) => {
                    const getFeedbackScore = (row) => {
                        if (!row["job_feedbacks"]) return -1;
                        const feedbacks = JSON.parse(row["job_feedbacks"]);
                        if (!feedbacks || feedbacks.length === 0) return -1;
                        return feedbacks.filter(f => f.wentWell).length / feedbacks.length;
                    };
                    return getFeedbackScore(a) - getFeedbackScore(b);
                },
            ]}
            data={sortedData}
        />
    );
}

export default UnreadFeedbackTable;